import { useContext } from 'react';

import {
  PageLayoutStateContext,
  PageLayoutDispatchContext,
} from 'layout/providers/PageLayoutProvider';

export const usePageLayoutState = () => useContext(PageLayoutStateContext);
export const usePageLayoutDispatch = () => useContext(PageLayoutDispatchContext);
